// Import app styles
import "./styles/main.scss";

// Add assets to /dist
import "./assets/favicon.ico";
import "./assets/logo.png";

// Add polyfills
import "core-js/es/promise";
import "core-js/es/array";
import "core-js/es/object/assign";
